var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "k-input-container" }, [
    _c(
      "div",
      {
        staticClass: "k-input",
        class: { "-error": _vm.error, "-disabled": _vm.disabled },
        on: {
          click: function($event) {
            !_vm.disabled ? _vm.handleClick() : ""
          }
        }
      },
      [
        _vm.label
          ? _c("label", { staticClass: "label", attrs: { for: _vm.name } }, [
              _vm._v(_vm._s(_vm.label))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-container" },
          [
            _vm.icon
              ? _c("k-icon", { staticClass: "icon", attrs: { icon: _vm.icon } })
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "money"
              ? _c(
                  "money",
                  _vm._b(
                    {
                      ref: "money",
                      staticClass: "input",
                      attrs: { value: _vm.internalValue },
                      model: {
                        value: _vm.internalValue,
                        callback: function($$v) {
                          _vm.internalValue = $$v
                        },
                        expression: "internalValue"
                      }
                    },
                    "money",
                    _vm.currencyMask,
                    false
                  )
                )
              : _vm.setType === "checkbox"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.internalValue,
                      expression: "internalValue"
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: _vm.mask,
                      expression: "mask"
                    }
                  ],
                  ref: "input",
                  staticClass: "input",
                  attrs: {
                    placeholder: _vm.placeholder,
                    disabled: _vm.disabled,
                    autocomplete: _vm.setTypeAutocomplete,
                    name: _vm.name,
                    type: "checkbox"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.internalValue)
                      ? _vm._i(_vm.internalValue, null) > -1
                      : _vm.internalValue
                  },
                  on: {
                    blur: function($event) {
                      _vm.touched = true
                    },
                    onfocusout: function($event) {
                      _vm.touched = true
                    },
                    change: function($event) {
                      var $$a = _vm.internalValue,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.internalValue = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.internalValue = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.internalValue = $$c
                      }
                    }
                  }
                })
              : _vm.setType === "radio"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.internalValue,
                      expression: "internalValue"
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: _vm.mask,
                      expression: "mask"
                    }
                  ],
                  ref: "input",
                  staticClass: "input",
                  attrs: {
                    placeholder: _vm.placeholder,
                    disabled: _vm.disabled,
                    autocomplete: _vm.setTypeAutocomplete,
                    name: _vm.name,
                    type: "radio"
                  },
                  domProps: { checked: _vm._q(_vm.internalValue, null) },
                  on: {
                    blur: function($event) {
                      _vm.touched = true
                    },
                    onfocusout: function($event) {
                      _vm.touched = true
                    },
                    change: function($event) {
                      _vm.internalValue = null
                    }
                  }
                })
              : _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.internalValue,
                      expression: "internalValue"
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: _vm.mask,
                      expression: "mask"
                    }
                  ],
                  ref: "input",
                  staticClass: "input",
                  attrs: {
                    placeholder: _vm.placeholder,
                    disabled: _vm.disabled,
                    autocomplete: _vm.setTypeAutocomplete,
                    name: _vm.name,
                    type: _vm.setType
                  },
                  domProps: { value: _vm.internalValue },
                  on: {
                    blur: function($event) {
                      _vm.touched = true
                    },
                    onfocusout: function($event) {
                      _vm.touched = true
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.internalValue = $event.target.value
                    }
                  }
                })
          ],
          1
        ),
        _vm._v(" "),
        _vm.type === "password"
          ? _c("show-password", {
              staticClass: "show-password",
              attrs: { show: _vm.showPassword },
              nativeOn: {
                click: function($event) {
                  _vm.showPassword = !_vm.showPassword
                }
              }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "k-input-feedback" }, [
      _vm.error ? _c("span", [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22cd93d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22cd93d0","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/kaledo-components/src/components/KInput.vue
// module id = 2058
// module chunks = 1610